/**
 * Should the auth modal render its close (X) button?
 *
 * Extracted from `AuthModal` so the rule is testable on its own. It carries more
 * weight than it looks: in the DUP-1903 `onboarding_first` arm the opt-in step's
 * Skip is removed, so this X is the ONLY exit from that step. If it fails to
 * render there, a shopper whose account has no email (a phone sign-up, ~17.6% of
 * registrations) meets a pre-ticked toggle, an empty email field, a CTA blocked
 * until they type one, no Skip — and no way out at all.
 *
 * Two independent reasons to show it:
 *   - the modal was never locked in the first place (`!disableClose`), e.g. the
 *     ordinary sign-in modal; or
 *   - onboarding is on screen AND the arm has asked for the X as its exit.
 *
 * The second must stay gated on BOTH: `onboardingCloseable` alone would offer an
 * exit while the sign-up gate is still unsatisfied, and `onboardingActive` alone
 * would unlock the locked results wall for every arm.
 *
 * Note this cannot prove the X appears in the live flow — that also depends on
 * the flag resolving to `onboarding_first`, and on both context flags being set
 * (they land via effects, so the first paint can miss by a tick). It pins the
 * decision itself, which is the part that used to be a bare inline boolean.
 */
export function showModalClose({
  disableClose,
  onboardingActive,
  onboardingCloseable,
}: {
  disableClose: boolean
  onboardingActive: boolean
  onboardingCloseable: boolean
}): boolean {
  return !disableClose || (onboardingActive && onboardingCloseable)
}

export default showModalClose
